import React, { useEffect, useState } from "react";
import { FaFileInvoice } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";
import Tooltip from "../../Tooltip";

function SummaryCards({ summaryData, onClick }) {
    const [selectedId, setSelectedId] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(null);

    const currentDueData = [
        {
            amount: "₹" + (summaryData?.total || 0),
            label: "Total Collections",
            color: "text-black",
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'TC',
        },
        {
            amount: "₹" + (summaryData?.rent || 0),
            label: `Rent Collections`,
            color: "text-black",
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'R',
        },
        {
            amount: "₹" + (summaryData?.security || 0),
            label: `Security Collections`,
            color: "text-black",
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'S',
        },
        {
            amount: "₹" + (summaryData?.other || 0),
            label: `Other Collections`,
            color: "text-black",
            // subLabel: `Fine Due`,
            // subTitle: (summaryData?.fineDuesAmt || '0'),
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'O',
        },
    ];

    return (
        <Wrapper>
            <ScrollCard>
                {currentDueData.map((item, index) => (
                    <Card selectedId={selectedId} index={index} key={index} onClick={() => {
                        setSelectedId(index);
                        onClick(item.filter);
                    }
                    }>
                        <div className="h-16">
                            <div className='flex flex-row'>
                                <Value color={item.color}>{item.amount}</Value>
                                {item.subTitle &&
                                    <Tooltip label={item.subLabel}>
                                        <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(₹" + item.subTitle + ")"}</span>
                                    </Tooltip>
                                }
                            </div>
                            <Label>
                                {item.label}
                                <MdOutlineChevronRight className="text-gray-300" size={24} />
                            </Label>
                        </div>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}

const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-1`;
const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  
  ${({ color }) =>
        color}
`;

export default SummaryCards;
